<template>
  <div>
    <div
      class="children-list-card rounded-5 d-flex justify-content-between align-items-start nowrap"
      :class="
        full_width && border_bottom ? 'w-100 border-bottom px-0' : 'border w-75'
      "
    >
      <div class="left d-flex justify-content-start align-items-center nowrap">
        <!-- AVATAR -->
        <div
          class="avatar avatar-square avatar_md child-avatar brand_inverse_light_bg"
        >
          <img
            v-lazy="child_img"
            :alt="child_name"
            class="avatar-img"
            v-if="child_img"
          />
          <div
            class="avatar-text white-text font-weight-500"
            :class="child_name | setAvatarBg"
            v-else
          >
            {{ getInitial }}
          </div>
        </div>

        <!-- CHILD INFO -->
        <div class="child-info">
          <div class="child-name brand_primary font-weight-bold">
            {{ child_name }}
          </div>
          <div class="child-meta color_grey_dark" v-if="child_code">
            Class Code: &nbsp;{{ child_code }}
          </div>
          <div
            class="child-meta color_grey_dark text-uppercase"
            v-if="child_class_year"
          >
            {{ child_class_year }}
          </div>
        </div>
      </div>

      <!-- OPTIONS -->
      <div class="right">
        <div
          v-if="action == 'remove'"
          class="avatar option"
          @click="processClickofRemoveChild"
        >
          <span
            class="icon-decline flex-center border_grey_dark font-18"
          ></span>
        </div>
        <div v-else class="avatar option" @click="showMore">
          <span
            class="icon-decline flex-center border_grey_dark font-20"
          ></span>
        </div>

        <!-- <span class="icon-ellipsis-h flex-center border_grey_dark font-20"></span> -->
      </div>
    </div>

    <!-- MODAL -->
    <DeleteConnectedChild
      v-if="remove_child"
      :remove_id="child_id"
      @remountList="$emit('remount')"
      @closeTriggered="toggleRemoveChildModal"
    ></DeleteConnectedChild>
    <!-- MODAL -->
  </div>
</template>

<script>
import { setInitial } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";

export default {
  name: "ChildrenListCard",

  components: {
    DeleteConnectedChild: () =>
      import(
        /* webpackChunkName: "DeleteConnectedChild" */ "@/components/modalComps/parentModals/DeleteConnectedChild"
      ),
  },

  props: {
    action: {
      type: String,
      default: "remove",
    },
    index: Number,
    child_id: Number,
    child_img: String,
    child_name: String,
    child_code: String,
    child_class_year: String,
    full_width: {
      type: Boolean,
      default: false,
    },
    border_bottom: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getInitial() {
      return setInitial(this.child_name);
    },
  },

  filters: {
    setAvatarBg(value) {
      return setProfileBg(value);
    },
  },

  data() {
    return {
      showMore: false,
      remove_child: false,
      page_type: this.$route.path.split("/")[3],
    };
  },

  methods: {
    toggleRemoveChildModal() {
      this.remove_child = !this.remove_child;
    },

    processClickofRemoveChild() {
      if (this.page_type === "upgrade-plan")
        this.$emit("triggerRemove", this.child_id);
      else this.toggleRemoveChildModal();
    },
  },
};
</script>

<style lang="scss">
.children-list-card {
  box-sizing: border-box;
  padding: 15px;
  margin-bottom: 10px;
  transition: all 0.4s ease-in-out;

  @include breakpoint_max(lg) {
    width: 100% !important;
  }

  &:hover {
    transform: scale(0.97);
  }

  .child-avatar {
    margin-right: 15px;
  }

  .child-info {
    .child-name {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 4px;

      @include breakpoint_max(md) {
        font-size: 15px;
      }

      @include breakpoint_max(sm) {
        font-size: 14px;
      }
    }

    .child-meta {
      font-size: 14px;
      line-height: 19px;

      @include breakpoint_max(md) {
        font-size: 13px;
      }

      @include breakpoint_max(sm) {
        font-size: 12px;
      }
    }
  }

  .option {
    transition: all 0.4s ease-in-out;

    &:hover {
      background: $brand_inverse_light;
    }
  }
}
</style>
